import type { ReactNode } from 'react';
import { Flex, Typography } from 'antd';

const { Title, Text } = Typography;

type InboundIntakeStepPanelProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  children?: ReactNode;
  action?: ReactNode;
};

export function InboundIntakeStepPanel({
  icon,
  title,
  description,
  children,
  action,
}: InboundIntakeStepPanelProps) {
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      style={{
        minHeight: 320,
        padding: '48px 32px',
        textAlign: 'center',
      }}
    >
      {icon}
      <Title level={4} style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
        {title}
      </Title>
      {description ? (
        <Text
          type="secondary"
          style={{
            fontSize: 14,
            lineHeight: '22px',
            maxWidth: 420,
            whiteSpace: 'pre-line',
          }}
        >
          {description}
        </Text>
      ) : null}
      {children}
      {action}
    </Flex>
  );
}
